/* global process */

// GET with Promise
import get from '../../plugins/get';

import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';

import SnazzyInfoWindow from 'snazzy-info-window';

import getDistance from '../../plugins/get-distance';
import mapStyles from '../../plugins/map-styles';

export default () => {

  const autocomplete = new google.maps.places.Autocomplete(document.getElementById('address-search'), {
    componentRestrictions: {
      country: 'us'
    }
  });

  let mapBounds,
      mapCenter,
      numberCommunities,
      searchRadius,
      filteredType;

  // empty array to store our map markers
  const markers = [];

  // empty array to store our map infowindows
  const infoWindows = [];

  // Map Options
  const mapOptions = {
    zoom: 7,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    gestureHandling: 'cooperative',
    scrollwheel: false,
    styles: mapStyles
  };

  // Marker icon
  const markerIcon = {
    url: '/assets/images/map-marker.svg',
    anchor: new google.maps.Point(12, 30),
    scaledSize: new google.maps.Size(24, 30),
    origin: new google.maps.Point(0, 0)
  };

  // Marker icon when active (clicked)
  const markerIconActive = {
    url: '/assets/images/map-marker-active.svg',
    anchor: new google.maps.Point(12, 30),
    scaledSize: new google.maps.Size(24, 30),
    origin: new google.maps.Point(0, 0)
  };

  // Marker icon for search location
  const markerIconSearch = {
    url: '/assets/images/map-marker-search.svg',
    anchor: new google.maps.Point(12, 12),
    scaledSize: new google.maps.Size(24, 24),
    origin: new google.maps.Point(0, 0)
  };

  // isotope options
  const isotopeOptions = {
    itemSelector: '.find-community-panel-item',
    layoutMode: 'vertical',
    stagger: 30,
    getSortData: {
      distance: '.find-community-panel-item-distance-number parseInt'
    }
  };

  // get locations text from data attribute for translatability
  const locationsText = $('.find-community-results-panel-number').data('text');

  // Clear address field and disable search button on page load/refresh
  $('[data-filter="address"] input').val('');
  $('.find-community-filters-button').attr('disabled', true);

  // Get radius on page load
  $('.find-community-filters-button').attr('data-radius', $('[data-filter="radius"] select').val());

  $('html')
    // Disable/enable address search Go button depending on if field has value or not
    .on('input', '[data-filter="address"] input', (e) => {
      $('[data-filter="address"] input').removeClass('-invalid');
      $('select[data-filter=type]').attr('disabled', false);
      if ($(e.currentTarget).val()) {
        $('.find-community-filters-button').attr('disabled', false);
      } else {
        $('.find-community-filters-button').attr('disabled', true);
      }
      $('.find-community-filters-button').attr('data-address', $(e.currentTarget).val());
    })
    // Update radius data attribute when radius dropdown is changed
    .on('change', '[data-filter="radius"] select', (e) => {
      $('.find-community-filters-button').attr('data-radius', $(e.currentTarget).val());
    })
    // Trigger search when enter key is pressed
    .on('keypress', '[data-filter="address"] input', (e) => {
      if (e.keyCode === 13 && $('.find-community-filters-button').attr('disabled') !== 'disabled') {
        $('.find-community-filters-button').trigger('click');
      }
    })
  ;

  // Instantiate map with mapOptions
  const map = new google.maps.Map(document.getElementById('community-map'), mapOptions);

  // Instantiate map bounds to draw the map based on markers
  mapBounds = new google.maps.LatLngBounds();

  // HTTP request with Promise to get Communities
  get(process.env.COMMUNITIES_ENDPOINT).then(JSON.parse).then((communities) => {

    numberCommunities = communities.length;

    $('.find-community-results-panel-number').text(`${numberCommunities} ${locationsText}`);

    // Loop through the communities in the response
    communities.map((community, index) => {

      // Coordinates of the community
      const communityLocation = new google.maps.LatLng(community.latitude, community.longitude);

      // Draw a marker for each random point
      const marker = new google.maps.Marker({
        position: communityLocation,
        icon: markerIcon,
        map,
        zIndex: index,
        animation: google.maps.Animation.DROP,
        draggable: false,
        optimized: false,
        data: {
          id: community.id,
          title: community.title,
          street: community.street,
          city: community.city,
          state: community.state,
          zip: community.zip,
          types: community.types,
          url: community.url,
          latitude: community.latitude,
          longitude: community.longitude
        }
      });

      // define our infowindows
      const infoWindow = new SnazzyInfoWindow({
        marker,
        map,
        closeWhenOthersOpen: true,
        shadow: false,
        pointer: false,
        border: false,
        position: communityLocation,
        offset: {
          top: '-56px',
          left: '0'
        },
        edgeOffset: {
          top: 25,
          right: 10,
          bottom: 25,
          left: 10
        },
        panOnOpen: false
      });

      // define our items in the panel list
      const labelMarkup = community.label ? `<div class="find-community-panel-item-label">${community.label}</div>` : '';
      const directionsURL = encodeURIComponent(community.title + ' ' + community.street + ' ' + community.city + ', ' + community.state + ' ' + community.zip);
      const typesText = community.types.join(', ');

      const typesClasses = community.types.map((el) => {
        if (el === 'Personal Care') {
          return '-assisted-living';
        } else {
          return '-' + el.replace(/\s+/g, '-').toLowerCase();
        }
      }).join(' ');

      const communityPanelItem = `
        <div tabindex="0" class="find-community-panel-item ${typesClasses}" data-id="${community.id}" data-inside-radius="false"${community.label ? ' data-has-label="true"' : ''}>
          <div class="find-community-panel-item-inner">
            <div class="find-community-panel-item-info">
              ${labelMarkup}
              <h5 class="find-community-panel-item-title"><a href="#" data-marker="${index}">${community.shortTitle}</a></h5>
              <div class="find-community-panel-item-types">${typesText}</div>
              <div class="find-community-panel-item-address">
                <a href="https://www.google.com/maps/dir/?api=1&destination=${directionsURL}" target="_blank">Get Directions</a>
              </div>
              <a href="tel:${community.phone}" class="find-community-panel-item-phone">${community.phone}</a>
            </div>
            <div class="find-community-panel-item-actions" style="background-image: url('${community.image}');">
              <a class="btn -bordered" href="${community.url}">View Community</a>
              <a class="btn -bordered" href="${community.url}#schedule-visit">Schedule Visit</a>
            </div>
          </div>
        </div>`;

      // append location panel items to the pane
      $('.find-community-panel-items').append(communityPanelItem);

      // define our infowindow content
      const infoWindowContent = `
        <div class="find-community-map-infowindow">
          <h5 class="find-community-map-infowindow-title"><a href="${community.url}">${community.shortTitle}</a></h5>
          <div class="find-community-map-infowindow-address">
            <div class="find-community-map-infowindow-address-line">${community.street}</div>
            <div class="find-community-map-infowindow-address-line">${community.city}, ${community.state} ${community.zip}</div>
          </div>
          <a class="find-community-map-infowindow-link" href="${community.url}">View Community</a>
        </div>
      `;

      // set the content of our infowindows with what we stored
      infoWindow.setContent(infoWindowContent);

      // Add markers to array
      markers.push(marker);

      // push our markers and infowindows to an array so we can use them outside of this function
      infoWindows.push(infoWindow);

      // Bring marker to front and change color
      google.maps.event.addListener(marker, 'click', () => {
        markers.map((marker) => {
          marker.setIcon(markerIcon);
          marker.setZIndex(index);
        });
        marker.setIcon(markerIconActive);
        marker.setZIndex(google.maps.Marker.MAX_ZINDEX + communities.length);

        // Pan to the marker and offset the height of the infowindow
        infoWindow._callbacks = {
          afterOpen: () => {
            const offsetY = $('.find-community-map-infowindow').outerHeight() / 1.4 * -1;
            map.panTo(communityLocation);
            map.panBy(0, offsetY);
            mapCenter = map.getCenter();
          }
        };
      });

      // Extend markerBounds with each marker
      mapBounds.extend(communityLocation);
    });

    // Draw the map with the boundaries from the markers
    map.fitBounds(mapBounds);

    // Set map center for resizing
    mapCenter = map.getCenter();

    // jQuery Bridget to allow the use of the Isotope class as a jQuery plugin
    jQueryBridget('isotope', Isotope, $);

    // Instantiate Isotope
    const $locationPanel = $('.find-community-panel-items').isotope(isotopeOptions);

    // temporary array for storing searched address markers
    const searchMarkers = [];

    $('.find-community-filters-button').on('click', (e) => {
      searchRadius = $(e.currentTarget).attr('data-radius');
      filteredType = $('select[data-filter="type"]').children('option:selected').text();

      $('.find-community-panel-item-distance').remove();
      $('.find-community-panel-no-results, .find-community-panel-invalid-search, .find-community-panel-error').hide();
      $('.ps__rail-y').show();

      // Clear map bounds to draw the map based on markers
      mapBounds = new google.maps.LatLngBounds();

      let returnedLocation,
          lat,
          lng,
          searchType
      ;

      if (typeof (Storage) !== 'undefined' && localStorage.getItem('communitiesPlace')) {
        searchType = 'fromStorage';
        returnedLocation = JSON.parse(localStorage.getItem('communitiesPlace'));
      } else {
        searchType = 'fromCurrentPage';
        returnedLocation = autocomplete.getPlace();
      }

      if (returnedLocation === undefined || returnedLocation.geometry === undefined) {
        $('.find-community-panel-invalid-search').fadeIn(300);
        $('[data-filter="address"] input').addClass('-invalid').trigger('blur');
        return false;
      }

      const location = returnedLocation.geometry.location;

      if (searchType === 'fromStorage') {
        lat = location.lat;
        lng = location.lng;
      } else {
        lat = location.lat();
        lng = location.lng();
      }

      const position = new google.maps.LatLng(lat, lng);

      // Draw a marker for searched address
      const searchMarker = new google.maps.Marker({
        position,
        icon: markerIconSearch,
        zIndex: 9999999,
        animation: google.maps.Animation.DROP,
        draggable: false,
        optimized: false
      });

      // Add address searches to array so we can set the map
      searchMarkers.push(searchMarker);

      searchMarkers.map((el) => {
        // searched location
        if (el.position === position) {
          el.setMap(map);
          // not searched location
        } else {
          el.setMap(null);
        }
      });

      mapBounds.extend(location);

      const addressComponents = [];

      /* eslint-disable indent */

      let stateText,
          zipText;

      // Loop through address components from response to formulate a string
      returnedLocation.address_components.map((el, index) => {
        switch (el.types[0]) {
          // street number from response
          case 'street_number':
            addressComponents.push(el.long_name + ' ');
            break;
          // street from response
          case 'route':
            addressComponents.push(el.long_name + ', ');
            break;
          // city from response
          case 'locality':
            addressComponents.push(el.long_name + ', ');
            break;
          // state from response
          case 'administrative_area_level_1':
            stateText = index === returnedLocation.address_components.length - 2 ? el.short_name : el.short_name + ', ';
            addressComponents.push(stateText);
            break;
          // zip code from response
          case 'postal_code':
            zipText = index === 0 ? el.short_name + ', ' : el.short_name;
            addressComponents.push(zipText);
            break;
          default:
        }
      });

      /* eslint-enable indent */

      // Join address components into a string
      const addressText = addressComponents.join('');

      // Loop through markers to check if they're inside of the radius
      markers.map((el) => {

        // Get distance between the marker and the searched location
        const distanceBetween = getDistance(el.data.latitude, el.data.longitude, lat, lng);

        // Check to see if a marker is inside of the radius
        if (distanceBetween <= searchRadius) {

          el.data.inRadius = true;
          $('.find-community-panel-item[data-id="' + el.data.id + '"]').addClass('-in-radius');

          const distanceLabelText = `
            <div class="find-community-panel-item-distance">
              <div class="find-community-panel-item-distance-number">${distanceBetween.toFixed()}</div>
              <div class="find-community-panel-item-distance-text">
                <div class="find-community-panel-item-distance-text-line">miles</div>
                <div class="find-community-panel-item-distance-text-line">away</div>
              </div>
            </div>
          `;

          // Distance label in the location panel item
          $('.find-community-panel-item[data-id="' + el.data.id + '"]').attr('data-distance', distanceBetween.toFixed()).prepend(distanceLabelText);

          // filtering by all
          if ($('select[data-filter="type"]').val() === '*') {
            el.setMap(map);
            mapBounds.extend(el.position);

          // filtering by type
          } else {

            /* eslint-disable no-lonely-if */

            // marker matches current selected type
            if (el.data.types.indexOf(filteredType) > -1) {
              el.setMap(map);
              mapBounds.extend(el.position);

            // marker doesn't match current selected type
            } else {
              el.setMap(null);
            }
            /* eslint-enable no-lonely-if */
          }
        // Outside of the radius so remove from the map
        } else {
          el.data.inRadius = false;
          $('.find-community-panel-item[data-id="' + el.data.id + '"]').removeClass('-in-radius');
          el.setMap(null);
        }

      });

      let concatFilters;

      if ($('select[data-filter="type"]').val() === '*') {
        concatFilters = '.-in-radius';
      } else {
        concatFilters = `.-in-radius${$('select[data-filter="type"]').val()}`;
      }

      $locationPanel.isotope('updateSortData').isotope({
        sortBy: 'distance'
      });

      $locationPanel.isotope({
        filter: concatFilters
      });

      $('.find-community-results-panel-number').text(`${$locationPanel.data('isotope').filteredItems.length}  ${locationsText}`);
      $('.find-community-results-panel-radius').text(searchRadius);
      $('.find-community-results-panel-address').text(addressText);
      $('.find-community-results-panel-location').show();

      // Draw the map with the boundaries from the markers
      map.fitBounds(mapBounds);

      // Make the maximum zoom 15
      if (map.getZoom() > 15) {
        map.setZoom(15);
      }

      // handle no results
      if (!$locationPanel.data('isotope').filteredItems.length) {
        $('.find-community-panel-no-results').fadeIn(300);
        $('select[data-filter=type]').attr('disabled', true);
        // Center map and zoom based on radius and address
        const circ = new google.maps.Circle();
        circ.setRadius(searchRadius * 1609.0);
        circ.setCenter(new google.maps.LatLng(lat, lng));
        map.setCenter(new google.maps.LatLng(lat, lng));
        map.fitBounds(circ.getBounds());
      }

      return true;

    });

    // Filtering by type
    $('html').on('change', 'select[data-filter="type"]', (e) => {

      $('.find-community-panel-no-results, .find-community-panel-invalid-search, .find-community-panel-error').hide();

      if ($locationPanel.data('isotope').filteredItems.length) {
        // Clear map bounds to draw the map based on markers
        mapBounds = new google.maps.LatLngBounds();
      }

      // close any open infoWindows
      infoWindows.map((el) => {
        el.close();
      });

      let concatFilters;

      if ($('[data-filter="address"] input').val()) {
        if ($('select[data-filter="type"]').val() === '*') {
          concatFilters = '.-in-radius';
        } else {
          concatFilters = `.-in-radius${$('select[data-filter="type"]').val()}`;
        }
      } else {
        concatFilters = $('select[data-filter="type"]').val();
      }

      // filter panel items
      $locationPanel.isotope({
        filter: concatFilters
      });

      // get current selected option text
      const filterText = $(e.currentTarget).children('option:selected').text();

      // loop through markers to update map
      markers.map((el) => {

        // filtering by type and address
        if ($('[data-filter="address"] input').val()) {

          // filtering by all
          if ($(e.currentTarget).children('option:selected').val() === '*' && el.data.inRadius === true) {
            el.setMap(map);
            mapBounds.extend(el.position);

          // marker matches current selected type
          } else if (el.data.types.indexOf(filterText) > -1 && el.data.inRadius === true) {
            el.setMap(map);
            mapBounds.extend(el.position);

          // marker doesn't match current selected type
          } else {
            el.setMap(null);
          }

          // only filtering by type
        } else {

          /* eslint-disable no-lonely-if */

          // filtering by all
          if ($(e.currentTarget).children('option:selected').val() === '*') {
            el.setMap(map);
            mapBounds.extend(el.position);

          // marker matches current selected type
          } else if (el.data.types.indexOf(filterText) > -1) {

            el.setMap(map);
            mapBounds.extend(el.position);

          // marker doesn't match current selected type
          } else {
            el.setMap(null);
          }

          /* eslint-enable no-lonely-if */

        }
      });

      if ($locationPanel.data('isotope').filteredItems.length) {
        // Draw the map with the boundaries from the markers
        map.fitBounds(mapBounds);

        // Make the maximum zoom 15
        if (map.getZoom() > 15) {
          map.setZoom(15);
        }
      }

      // set results text
      if ($('select[data-filter="type"]').val() === '*') {
        $('.find-community-results-panel-number').text(`${$locationPanel.data('isotope').filteredItems.length} ${locationsText}`);
      } else {
        const typeText = $('select[data-filter="type"] option:selected').text();
        $('.find-community-results-panel-number').text(`${$locationPanel.data('isotope').filteredItems.length} ${typeText} ${locationsText}`);
      }

      // handle no results
      if (!$locationPanel.data('isotope').filteredItems.length) {
        $('.find-community-panel-no-results').fadeIn(300);
      }

    });

    // pre-select type of living if query param 'type' is present
    const typeOfLiving = decodeURIComponent(location.search.substring(6));
    if (typeOfLiving) {
      $('select[data-filter="type"]')[0].selectedIndex = $('select[data-filter="type"] option').toArray().map(jQuery.text).indexOf(typeOfLiving);
      $('select[data-filter="type"]').trigger('change');
    }

    // If browser supports localStorage and it's set by footer form
    if (typeof (Storage) !== 'undefined' && localStorage.getItem('communitiesAddress')) {

      // Set address from localStorage and trigger input event to update data attributes
      $('[data-filter="address"] input')
        .val(localStorage.getItem('communitiesAddress'))
        .trigger('input')
      ;

      // Trigger click of 'Go' button to filter results
      $('.find-community-filters-button').trigger('click');

      // Clear local storage so it only applies when coming from the footer
      localStorage.removeItem('communitiesAddress');
      localStorage.removeItem('communitiesPlace');
    }

  });

  // Custom Zoom Controls
  const zoomControlDiv = document.createElement('div');
  zoomControlDiv.className = 'find-community-map-zoom-controls';
  new ZoomControl(zoomControlDiv, map);
  zoomControlDiv.index = 1;
  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomControlDiv);

  // center map on resize
  google.maps.event.addListener(window, 'resize', () => {
    google.maps.event.trigger(map, 'resize');
    map.setCenter(mapCenter);
  });

  $('html')
    // open infowindow when item in panel is clicked and pan to marker
    .on('click', '.find-community-panel-item-title a', (e) => {
      e.preventDefault();

      const currentMarker = markers[$(e.currentTarget).data('marker')],
            currentInfoWindow = infoWindows[$(e.currentTarget).data('marker')];

      currentInfoWindow.open();

      markers.map((marker, index) => {
        marker.setIcon(markerIcon);
        marker.setZIndex(index);
        marker.isOpen = false;
      });
      currentMarker.setIcon(markerIconActive);
      currentMarker.setZIndex(google.maps.Marker.MAX_ZINDEX + numberCommunities);
      currentMarker.isOpen = true;

      // Pan to the marker and offset the height of the infowindow
      currentInfoWindow._callbacks = {
        afterOpen: () => {
          const offsetY = $('.find-community-map-infowindow').outerHeight() / 1.4 * -1;
          map.panTo(new google.maps.LatLng(currentMarker.data.latitude, currentMarker.data.longitude));
          map.panBy(0, offsetY);
          mapCenter = map.getCenter();
        }
      };
    })
    // change marker icon when hovering over community titles in panel
    .on('mouseenter focus blur mouseleave', '.find-community-panel-item-title a', (e) => {
      if (e.type === 'mouseenter' || e.type === 'focus') {
        markers.map((marker, index) => {
          if (!marker.isOpen) {
            marker.setIcon(markerIcon);
            marker.setZIndex(index);
          }
        });
        markers[$(e.currentTarget).data('marker')].setIcon(markerIconActive);
        markers[$(e.currentTarget).data('marker')].setZIndex(google.maps.Marker.MAX_ZINDEX + numberCommunities);
      } else {
        markers.map((marker, index) => {
          if (!marker.isOpen) {
            marker.setIcon(markerIcon);
            marker.setZIndex(index);
          }
        });
      }
    })
  ;

  // Custom zoom controls
  function ZoomControl(controlDiv, map) {

    // Create control wrapper
    const controlWrapper = document.createElement('div');
    controlWrapper.className = 'find-community-map-zoom-controls-inner';
    controlDiv.appendChild(controlWrapper);

    // Create zoomIn button
    const zoomInButton = document.createElement('a');
    zoomInButton.className = 'find-community-map-zoom-controls-zoom-in';
    zoomInButton.href = '#';
    zoomInButton.textContent = '+';
    controlWrapper.appendChild(zoomInButton);

    // Create zoomOut button
    const zoomOutButton = document.createElement('a');
    zoomOutButton.className = 'find-community-map-zoom-controls-zoom-out';
    zoomOutButton.href = '#';
    zoomOutButton.textContent = '-';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    google.maps.event.addListener(zoomInButton, 'click', (e) => {
      e.preventDefault();
      $(e.currentTarget).trigger('blur');
      map.setZoom(map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    google.maps.event.addListener(zoomOutButton, 'click', (e) => {
      e.preventDefault();
      $(e.currentTarget).trigger('blur');
      map.setZoom(map.getZoom() - 1);
    });

  }

};
